import { Backdrop, ClickAwayListener, Popper, SxProps, Theme } from "@mui/material";
import React from "react";
import { StyledFilterPaper } from "./FilterPopover.tsx";
import { PopperPlacementType } from "@mui/material/Popper/BasePopper.types";

export interface FilterPopoverSubMenuProps {
    open: boolean;
    submenuAnchorRef: HTMLElement | undefined;
    children: React.ReactNode;
    handleSubmenuPaperEnter: () => void;
    placement?: PopperPlacementType;
    onBackdropClick?: () => void;
    paperSx?: SxProps<Theme>;
}

export const filterPopoverSubMenuWidth = 340;

// Popper rebuilds its instance whenever the modifiers array changes identity, and the rebuild resets the
// scroll position of any input inside it. The submenu re-renders on every keystroke, so an inline array
// would scroll a text field back to the start while the user types past its right edge.
const cascadingSideModifiers = [
    { name: "offset", options: { offset: [0, 12] } },
    { name: "flip", enabled: false },
];
const stackedModifiers = [
    { name: "offset", options: { offset: [0, 2] } },
    { name: "flip", enabled: false },
];

function FilterPopoverSubMenu(props: FilterPopoverSubMenuProps) {
    const { open, submenuAnchorRef, handleSubmenuPaperEnter, children, onBackdropClick } = props;

    const placement = props.placement ?? "right-start";
    const isCascadingSidePlacement = placement.startsWith("left") || placement.startsWith("right");

    return (
        <>
            <Backdrop
                open={open && onBackdropClick !== undefined}
                sx={{ zIndex: 1200 }}
                invisible
                onClick={() => {
                    if (onBackdropClick) {
                        onBackdropClick();
                    }
                }}
            ></Backdrop>
            <Popper
                open={open}
                anchorEl={submenuAnchorRef}
                placement={placement}
                sx={{ minWidth: filterPopoverSubMenuWidth, zIndex: 1300 }}
                modifiers={isCascadingSidePlacement ? cascadingSideModifiers : stackedModifiers}
            >
                <StyledFilterPaper
                    onMouseEnter={handleSubmenuPaperEnter}
                    sx={[{ maxHeight: "none", padding: 0, paddingRight: 0, marginTop: 0 }, ...(Array.isArray(props.paperSx) ? props.paperSx : [props.paperSx])]}
                >
                    {children}
                </StyledFilterPaper>
            </Popper>
        </>
    );
}

export default FilterPopoverSubMenu;
